module.exports = __webpack_public_path__ + "img/huawei-p20-pro.7ef7640e.png";